__turbopack_context__.v({
  "sponsorLogo": "w5v9IG_sponsorLogo",
  "sponsorLogoRow": "w5v9IG_sponsorLogoRow",
});
